import React, { useState, useEffect } from 'react';
import { Card, CardContent } from './ui/card';
import { Star } from 'lucide-react';
import { testimonials as defaultTestimonials } from '../mockData';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Testimonials = () => {
  const [items, setItems] = useState(null);

  useEffect(() => {
    fetch(`${API}/content/testimonials`).then(r => r.json()).then(data => {
      if (data.length > 0) setItems(data);
    }).catch(() => {});
  }, []);

  const testimonials = items || defaultTestimonials;

  return (
    <section id="testimonials" className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="lg:text-5xl !font-bold !text-4xl mb-4 text-gray-900">Testimonials</h2>
          <p className="!text-xl text-gray-600"></p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {testimonials.map((testimonial) => (
            <Card key={testimonial.id} className="hover:shadow-xl transition-all duration-300 border-2 hover:border-green-200">
              <CardContent className="pt-6">
                <div className="flex gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="h-5 w-5 fill-yellow-400 text-yellow-400" />
                  ))}
                </div>
                <p className="text-gray-700 text-lg leading-relaxed mb-6 italic">
                  "{testimonial.text}"
                </p>
                <div className="flex items-center justify-between pt-4 border-t border-gray-200">
                  <div>
                    <p className="font-bold text-gray-900">{testimonial.name}</p>
                    <p className="text-sm text-gray-600">{testimonial.location}</p>
                  </div>
                  <div className="text-right">
                    <p className="text-sm font-medium text-green-700">{testimonial.service}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="text-center">
            <p className="text-4xl font-bold text-green-700 mb-2">500+</p>
            <p className="text-gray-600 font-medium">Projects Completed</p>
          </div>
          <div className="text-center">
            <p className="text-4xl font-bold text-green-700 mb-2">10+</p>
            <p className="text-gray-600 font-medium">Years Experience</p>
          </div>
          <div className="text-center">
            <p className="text-4xl font-bold text-green-700 mb-2">100%</p>
            <p className="text-gray-600 font-medium">Satisfaction Rate</p>
          </div>
          <div className="text-center">
            <p className="text-4xl font-bold text-green-700 mb-2">24hr</p>
            <p className="text-gray-600 font-medium">Response Time</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
